import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstantsComponent} from '../shared/global-constants/global-constants.component';

@Injectable({
  providedIn: 'root'
})
export class AccommodationService {

  constructor(private httpService: HttpClient) {
  }

  apiUrl = GlobalConstantsComponent.apiURL;
  tekloUrl = GlobalConstantsComponent.tekloUrl;

  public getSearchElements(search) {
    return this.httpService.get<any>(this.tekloUrl + `accommodation/getSearchElements/` + search);
  }

  public getFavoriteRooms() {
    return this.httpService.get<any>(this.apiUrl + `user/getUserFavorites/`);
  }

  // ALERTS
  public getAlertsByUser() {
    return this.httpService.get<any>(this.apiUrl + `user/getUserAlerts/`);
  }

  public createAlert(datas) {
    return this.httpService.post(`${this.apiUrl}alert/create`, {datas});
  }

  public updateAlert(datas, alertId: number) {
    return this.httpService.post(`${this.apiUrl}alert/update/` + alertId, {datas});
  }

  public deleteAlert(alertId: number) {
    return this.httpService.post(this.apiUrl + 'user/deleteAlert/' + alertId, {}) as any;
  }


  //----------------

}
